<template>
  <div
    id="custom"
    class="editor-container"
  >
    <div class="fixed">
      <EditorMenu />
      <GlassPreview>
        <div
          class="text-container"
          :data-attribute-value="product.attribute_values.fontType.id"
        >
          <p class="primary-text">
            {{ primaryText }}
          </p>
          <p class="secondary-text">
            {{ product.attributes.secondaryText }}
          </p>
        </div>
      </GlassPreview>
    </div>
    <div class="product-fields">
      <!-- Sold -->
      <SoldCapacity v-if="soldCapacity" />
      <!-- Editor -->
      <div class="form-fields">
        <ImageHandler />
        <CustomFields />
        <GlobalAttributes />
        <AddToCart />
      </div>
      <Loader />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AddToCart from './AddToCart'
import Attribute from './attributes/Attribute'
import GlobalAttributes from './attributes/GlobalAttributes'
import CustomFields from './attributes/CustomFields'
import Services from '../../../packages/views/product-service/Services'
import useCustom from '../useCustom'
import ImageHandler from './ImageHandler'
import useProduct from '../useProduct'
import GlassPreview from './glass-preview/Base'
import Loader from '../../../packages/views/loader/Loader'
import EditorMenu from './EditorMenu.vue'
import SoldCapacity from './SoldCapacity.vue'

export default {
  components: {
    Loader,
    Services,
    CustomFields,
    GlobalAttributes,
    Attribute,
    AddToCart,
    ImageHandler,
    GlassPreview,
    EditorMenu,
    SoldCapacity,
  },
  computed: {
    ...mapGetters({
      product: 'product/getProduct',
      soldCapacity: 'product/getSoldCapacity',
    }),
  },
  setup() {
    const { primaryText } = useCustom()
    const { imageUrl } = useProduct()

    return {
      primaryText,
      imageUrl,
    }
  },
}
</script>
